module.exports = __webpack_public_path__ + "img/002a398728020d214f2fcb8404b22783.png";